var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4065_8162)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 0.5,
    rx: 8,
    ry: 0.5,
    transform: "matrix(1 0 0 -1 2 18)",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4 5C4 3.89543 4.89543 3 6 3H10H13L13.4142 3.41421C13.7893 3.78929 14 4.29799 14 4.82843V5H14.1716C14.702 5 15.2107 5.21071 15.5858 5.58579L16 6V10V15C16 16.1046 15.1046 17 14 17H6C4.89543 17 4 16.1046 4 15V5Z",
    fill: "url(#paint0_linear_4065_8162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3L14.5 4.5L16 6H14C13.4477 6 13 5.55228 13 5V3Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4065_8162)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 16,
    height: 5,
    rx: 1,
    fill: "#4AABAE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4065_8162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.5 9.72386 2.72386 9.5 3 9.5H17C17.2761 9.5 17.5 9.72386 17.5 10V13C17.5 13.2761 17.2761 13.5 17 13.5H3C2.72386 13.5 2.5 13.2761 2.5 13V10Z",
    fill: "url(#paint1_linear_4065_8162)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4065_8162",
    x: 0,
    y: 15,
    width: 20,
    height: 5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4065_8162"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4065_8162",
    x: 2,
    y: 9,
    width: 16,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4065_8162"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4065_8162",
    x: 0.5,
    y: 7.5,
    width: 19,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4065_8162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4065_8162",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4065_8162",
    x1: 10,
    y1: 3,
    x2: 11.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4065_8162",
    x1: 10,
    y1: 9.5,
    x2: 10,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DB4B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B0B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.3e7fa60f12e1112c21ba9df83b781305.svg";
export { ForwardRef as ReactComponent };